export default {
  table: {
    day: "day",
  },
};
